import React, { useEffect, useState } from 'react'
import gridClasses from '../../styles/grid.module.css'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import classNames from 'classnames'
import { ReactComponent as RightArrow } from '../../assets/icons/arrow-right.svg'
import { BlogPostCard } from '../../components/Cards/GeneralCard/Card'
import PageChanger from '../../components/PageChanger/PageChanger'
import Footer from '../../components/Footer/Footer'
import { blogActions, blogSelectors } from './blogSlice'
import { useDispatch, useSelector } from 'react-redux'
import { blogApi } from './blogApi'
import CardLoader from '../../components/loaders/CardLoader'
import classes from './blog.module.css'
import { Header } from '../../components/Header/Header'
import {
    Hero,
    HeroContent,
    HeroSubtitle,
    HeroTitle,
} from '../../components/Hero/Hero'
import BlogBanner from '../../assets/images/blog-banner.jpg'

const Blog = () => {
    const dispatch = useDispatch()

    const posts = useSelector(blogSelectors.getPostsState)
    const isFetching = useSelector(blogSelectors.getIsFetchingState)
    const paging = useSelector(blogSelectors.getPagingState)

    const fetchPosts = (page = 1) => {
        dispatch(blogApi.getPosts({ pageNo: page, pageSize: 10 }))
    }

    const [currentPage, setCurrentPage] = useState(paging.pageNo)

    useEffect(() => {
        setCurrentPage(paging.pageNo)
    }, [paging.pageNo])

    useEffect(() => {
        fetchPosts(currentPage)

        return () => {
            dispatch(blogActions.resetPosts())
        }
    }, [currentPage])

    return (
        <>
            <div
                className={classNames(classes.topWrapper)}
                style={{ backgroundImage: `url(${BlogBanner})` }}
            >
                <Header className={classes.header} />
                <div className={classNames(gridClasses.container, classes.top)}>
                    <div>
                        <h1 className={classes.topHeader}>Stories We Share</h1>
                        <span className={classes.topLine} />
                        <div className={classes.latestBlogPost}>
                            <span className={classes.latestBlogPostText}>
                                Read our latest blog post
                            </span>
                            <span className={classes.latestBlogPostIcon}>
                                <span
                                    className={
                                        classes.latestBlogPostIconSegment
                                    }
                                />
                                <RightArrow
                                    className={classes.latestBlogPostIconArrow}
                                />
                            </span>
                        </div>
                    </div>
                    {isFetching ? (
                        <CardLoader className={classes.topBlogPost} />
                    ) : posts?.[0] ? (
                        <BlogPostCard
                            title={posts[0]?.caption}
                            imageUrl={posts[0]?.thumbnail}
                            date={posts[0]?.publisheddate}
                            author={`${posts[0]?.author?.firstname} ${posts[0]?.author?.lastname}`}
                            authorImage={posts[0]?.author?.dp}
                            className={classes.topBlogPost}
                            postId={posts[0]?.postid}
                        />
                    ) : null}
                </div>
            </div>
            <div className={gridClasses.container}>
                <h1 className={classes.storiesHeader}>All Stories</h1>
                <h3 className={classes.storiesSubtext}>
                    Get more business insights, templates and tools here
                </h3>
                <div className={classes.storiesGrid}>
                    {isFetching ? (
                        <>
                            <CardLoader />
                            <CardLoader />
                            <CardLoader />
                        </>
                    ) : (
                        posts.map(
                            ({
                                postid,
                                caption,
                                publisheddate,
                                thumbnail,
                                author,
                                authorImage,
                            }) => (
                                <BlogPostCard
                                    title={caption}
                                    author={`${author?.firstname} ${author?.lastname}`}
                                    authorImage={author?.dp}
                                    date={publisheddate}
                                    imageUrl={thumbnail}
                                    key={postid}
                                    className={classes.story}
                                    postId={postid}
                                />
                            )
                        )
                    )}
                </div>
                <div className={classes.alignEnd}>
                    <PageChanger
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        pageCount={paging?.pageCount}
                    />
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Blog
